import { apiClient } from './api';

/** 회사서류 (#159 — admin#101 에서 옮겨 옴) — 서버 `modules/company-docs` */
export type DocRule = 'EXPIRES' | 'ISSUED_3M' | 'NONE' | 'PER_BID';
export type DocState = 'valid' | 'expiring' | 'expired' | 'per-bid';

/** GET /company-docs/types — 종류 · 이름 · 규칙은 서버가 정한다 */
export interface DocTypeInfo { type: string; label: string; rule: DocRule }

export interface CompanyDocRow {
  id: number;
  type: string;
  name: string;
  issuedAt: string | null;
  /** 보여 줄 만료일 — 발급일 기준 서류는 계산한 값 */
  expiresAt: string | null;
  state: DocState;
  /** 원본 파일명 */
  fileName: string;
  updatedAt: string;
  note: string | null;
  fileSize: number;
  mimeType: string;
  /** 사람이 넣은 만료일(고칠 때 쓴다) */
  expiresAtInput: string | null;
}

export interface CompanyDocInput { type: string; name?: string; issuedAt?: string; expiresAt?: string; note?: string }

export const companyDocsApi = {
  list: (): Promise<CompanyDocRow[]> => apiClient.get('/company-docs'),
  types: (): Promise<DocTypeInfo[]> => apiClient.get('/company-docs/types'),
  create: (input: CompanyDocInput, file: File): Promise<CompanyDocRow> => {
    const form = new FormData();
    Object.entries(input).forEach(([k, v]) => v !== undefined && v !== '' && form.append(k, v));
    form.append('file', file);
    return apiClient.postForm('/company-docs', form);
  },
  update: (id: number, input: CompanyDocInput): Promise<CompanyDocRow> => apiClient.patch(`/company-docs/${id}`, input),
  remove: (id: number): Promise<void> => apiClient.delete(`/company-docs/${id}`),
  /** 원본을 받아 그 이름으로 저장 */
  download: async (doc: Pick<CompanyDocRow, 'id' | 'fileName'>) => {
    const blob = await apiClient.getBlob(`/company-docs/${doc.id}/file`);
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = doc.fileName;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  },
};
